import { render, staticRenderFns } from "./MenuDash.vue?vue&type=template&id=6ffa60d2&"
import script from "./MenuDash.vue?vue&type=script&lang=js&"
export * from "./MenuDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports